import { Watch, Component, Vue, Prop } from 'vue-property-decorator';
import { AgriFieldIncome, AgriFieldGroupDetail } from '@/types/Component';
import { AgriFieldIncomeResponse, AgriFieldGroupResponse, CsvDownload } from '@/types/APIResponse';
import { toCamel } from "snake-camel";

@Component({
    filters: {
        applyNumberFormat(value: number): string | null {
            return value.toLocaleString()
        },
        applyAmountFormat(value: number): string | null {
            return Math.round(value).toLocaleString().replace(/^-/, '▲')
        }
    }
})

export default class IncomeAndOutgoAgriFieldIncomeDetail extends Vue {
    @Prop()
    private agriFieldId!: string

    @Prop()
    private agriFieldGroupId!: string

    private agriFieldGroup: AgriFieldGroupDetail = {
        id: 'other',
        name: '所属なし',
        agriFields: []
    }
    private responseItem: AgriFieldIncome | null = null
    private sortByAmountAsc = false
    private sortByDateAsc = false;
    private parentPath = `/management/income-and-outgo/agri-field-groups/${this.agriFieldGroupId}`

    @Prop()
    private startDate!: string
    @Prop()
    private endDate!: string

    created() {
        if(this.agriFieldGroupId != this.agriFieldGroup.id) {
            this.getAgriFieldGroup()
        }
        this.getIncome()
    }

    private getAgriFieldGroup() {
        this.$apiClient.doRequest('get', `/admin/agri_field_groups/${this.agriFieldGroupId}`).then((res: AgriFieldGroupResponse) => {
            this.agriFieldGroup = toCamel(res) as AgriFieldGroupDetail
        })
    }

    private getIncome() {
        this.$apiClient.doRequest('get', `/admin/income_and_outgo/agri_field_groups/income/${this.agriFieldId}?start_date=${this.startDate}&end_date=${this.endDate}`).then((ret: AgriFieldIncomeResponse) => {
            this.responseItem = toCamel(ret) as AgriFieldIncome
            this.sortByDate();
        })
    }

    sortByAmount() {
        this.sortByAmountAsc = !this.sortByAmountAsc
        this.responseItem?.details.sort((a , b) => this.sortByAmountAsc ?
            a.amount - b.amount : b.amount - a.amount)
    }

    private sortDateClicked() {
        this.sortByDateAsc = !this.sortByDateAsc;
        this.sortByDate();
    }

    private sortByDate() {
        this.responseItem?.details.sort((a, b) => this.sortByDateAsc ?
            Date.parse(a.shippingDate) - Date.parse(b.shippingDate) : Date.parse(b.shippingDate) - Date.parse(a.shippingDate))
    }


    exportCsv() {
        this.$apiClient.getRequest(`/admin/income_and_outgo/agri_field_groups/income/${this.agriFieldId}/csv_export?start_date=${this.startDate}&end_date=${this.endDate}`).then((res: CsvDownload) => {
            this.$apiClient.csvDownload(res)
        })
    }
}